import { getPrimaryTextClass } from "helpers/sf_utils";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Card, CardBody, Col, Label, Row, Table } from "reactstrap";
import { updateLeadViolation, addLeadViolation, deleteLeadViolation } from "store/leads/lead_violations_actions";
import LeadEditDropdown from "./LeadEditDropdown";
import AddViolationModal from "../Modals/AddViolationModal";
import { MODE } from "helpers/sf_constants";
import LeadDatePicker from "./LeadDatePicker";
import LeadEditDropdownForNumberFields from "./LeadEditDropdownForNumberFields";
import { findViolationTypeFromID, optionsViolationDesc, optionsViolationTypes } from "helpers/sf_lead_constants";
import DeleteModal from "../DeleteModal";
import { VIOLATIONS_DELETE_STR } from "common/sf_strings";
import { deleteProspectViolation, updateProspectViolation } from "store/prospects/prospects_violations_actions";
import { addProspectViolation } from "store/prospects/actions";
import LeadDetailReadOnlyContext from "contexts/LeadDetailReadOnlyContext";
import { useContext } from "react";

const LeadViolations = (props) => {
    const isReadOnly = useContext(LeadDetailReadOnlyContext) || props?.isReadOnly;
    const [lead_data, setLeadData] = useState({})
    const { lead_id } = useParams();
    const { leads } = useSelector(state => ({
        leads: state.Leads.leads,
    }));
    const dispatch = useDispatch();
    let leadViolationUpdater = updateLeadViolation
    let leadViolationAdder = addLeadViolation
    let leadViolationDeleter = deleteLeadViolation
    if (props?.is_prospect) {
        leadViolationUpdater = updateProspectViolation;
        leadViolationAdder = addProspectViolation
        leadViolationDeleter = deleteProspectViolation
    }
    const [violationModalState, setViolationModalState] = useState({ active: false });
    const [deleteViolationModal, setdeleteViolationModal] = useState({ action: false, violation: {} });
    //Create a useeffect and get lead data from redux store from lead_id from useParams
    const getDriverNameFromApplicant = (applicant_id) => {
        if (lead_data?.lead_applicants?.length > 0) {
            const applicant = lead_data?.lead_applicants?.find(applicant => applicant.id === applicant_id);
            return applicant?.first_name + ' ' + applicant?.last_name;
        }
        return '--';
    }

    useEffect(() => {
        if (props?.lead_data) {
            setLeadData(props?.lead_data);
        }
    }, [props?.lead_data])

    const handleLaunchViolationModal = (value) => {
        setViolationModalState({ active: value });
    }

    const onClickSaveViolation = (mode, values) => {
        if (mode === MODE.EDIT) {
            dispatch(leadViolationUpdater({ lead_violation: values }))
        } else {
            dispatch(leadViolationAdder({ ...values }))
        }
        handleLaunchViolationModal(false)
    }

    // For Delete Violation Modal
    const launchDeleteViolationModal = (violation) => {
        setdeleteViolationModal({ action: true, violation: violation });
    };

    const onClickViolationModal = (payload) => {
        dispatch(leadViolationDeleter({ id: payload?.violation?.id }));
        setdeleteViolationModal({ action: false, violation: {} });
    };

    return (
        <React.Fragment>
            <DeleteModal
                deleteModalState={deleteViolationModal}
                onDeleteClick={onClickViolationModal}
                textMessage={VIOLATIONS_DELETE_STR}
                onCloseClick={() => setdeleteViolationModal({ action: false, violation: {} })}
                cancelButton
            />
            <AddViolationModal
                title={"Violation"}
                leadApplicants={lead_data?.lead_applicants || null}
                show={violationModalState}
                onClickSaveViolation={onClickSaveViolation}
                onCloseClick={() => handleLaunchViolationModal(false)}
            />
            <Card>
                <CardBody className="pt-0">
                    <Row>
                        <div className="px-0">
                            <Table className="mb-0 text-black">
                                {lead_data?.lead_violations?.map((violation, idx) =>
                                (
                                    <tbody id={idx === 0 ? 'primary_vehicles' : 'secondary_vehicles'}>
                                        <tr>
                                            <td style={{ width: '33%' }}>
                                                <Col className="d-flex align-items-center pt-1 my-2">
                                                    <i className={`bx fs-24 bx-car ${getPrimaryTextClass()}`} />
                                                    <div className="mx-2 fs-15 font-weight-semibold">
                                                        Violation #{idx + 1}
                                                    </div>
                                                    {!isReadOnly &&
                                                        <div className="ms-1 fs-13 text-sfblue font-weight-semibold align-self-end">
                                                            <a onClick={() => setViolationModalState({ active: true, mode: MODE.EDIT, values: violation })}>Edit</a>
                                                        </div>
                                                    }
                                                </Col>
                                            </td>
                                            <td></td>
                                            <td style={{ width: '33%' }}>
                                                {!isReadOnly &&
                                                    <Col className={`${getPrimaryTextClass()} pt-1 my-2 font-weight-semibold`}>
                                                        <div className="d-flex flex-row-reverse">
                                                            <a
                                                                className={`d-flex ${getPrimaryTextClass()}`}
                                                                onClick={() => launchDeleteViolationModal(violation)}
                                                            >
                                                                <i className="mdi mdi-close me-2" />
                                                                Remove
                                                            </a>
                                                        </div>
                                                    </Col>
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Driver Name
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            title='Driver Name'
                                                            field={getDriverNameFromApplicant(violation?.lead_applicant_id) || ''}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = violation?.id
                                                                data.lead_applicant_id = value
                                                                dispatch(leadViolationUpdater({ lead_violation: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-center">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Date
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadDatePicker
                                                            title="Date"
                                                            field={violation?.dt || "--"}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = violation?.id
                                                                data.dt = value
                                                                dispatch(leadViolationUpdater({ lead_violation: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ width: '33%' }}>
                                                {(violation?.violation_type_id === 2 || violation?.violation_type_id === 3) ?
                                                    <div className="d-flex align-items-center">
                                                        <Label className="mb-0 font-weight-semibold me-2">
                                                            Amount Paid
                                                        </Label>
                                                        <div className="d-flex align-items-center">
                                                            <LeadEditDropdownForNumberFields
                                                                dollarFormatter={true}
                                                                title='Amount Paid'
                                                                field={violation?.paid_amount}
                                                                onSave={(value) => {
                                                                    let data = {}
                                                                    data.id = violation?.id
                                                                    data.paid_amount = value
                                                                    dispatch(leadViolationUpdater({ lead_violation: data }))
                                                                }}
                                                                onCancel={() => { }}
                                                            />
                                                        </div>
                                                    </div>
                                                    : null}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: '33%' }}>
                                                <div className="d-flex align-items-top">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Violation Type
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            isDropdown={true}
                                                            options={optionsViolationTypes}
                                                            title='Violtion Type'
                                                            field={findViolationTypeFromID(violation?.violation_type_id)}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = violation?.id
                                                                data.violation_type_id = value
                                                                dispatch(leadViolationUpdater({ lead_violation: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                            <td colSpan={2}>
                                                <div className="d-flex align-items-top">
                                                    <Label className="mb-0 font-weight-semibold me-2">
                                                        Description
                                                    </Label>
                                                    <div className="d-flex align-items-center">
                                                        <LeadEditDropdown
                                                            isDropdown={true}
                                                            options={optionsViolationDesc}
                                                            title='Description'
                                                            field={violation?.desc}
                                                            onSave={(value) => {
                                                                let data = {}
                                                                data.id = violation?.id
                                                                data.desc = value
                                                                dispatch(leadViolationUpdater({ lead_violation: data }))
                                                            }}
                                                            onCancel={() => { }}
                                                        />
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                ))}
                            </Table>
                        </div>
                        <div className="text-sfblue font-weight-semibold mt-4">
                            {!isReadOnly && <a onClick={() => handleLaunchViolationModal(true)}>+ Add Violation</a>}
                        </div>
                    </Row>
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

export default LeadViolations